import { memo } from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { isEqual } from 'underscore';
import { selectGame } from 'casino-selectors/games';
import GameContainer from './game_container';

const GameRedux = memo(({ gameId, gameInstance, ...rest }) => {
  const game = useSelector((state) => selectGame(state, gameId), isEqual);

  return <GameContainer {...rest} game={{ ...game, ...gameInstance }} />;
});

GameRedux.propTypes = {
  gameId: PropTypes.number.isRequired,
  gameInstance: PropTypes.instanceOf(Object),
};

GameRedux.defaultProps = {
  gameInstance: {},
};

export default GameRedux;
